<template>
    <div class="move-button" ref="moveBtnRef"
         @mousedown="btnDown"
         @touchstart="btnDown"
         @mousemove="btnMove"
         @touchmove="btnMove"
         @mouseup="btnEnd"
         @touchend="btnEnd"
         @touchcancel="btnEnd">
        <!--<img src="../assets/image/beauty.png" class="img-style"   @click="switchDiagram">-->
        <img src="../assets/image/close.png" width="20" height="20" @click="close"
             style="margin-left: -20px;margin-top: -20px;float: right" v-show="imgShow" v-if="gifUrl">
        <img :src=gifUrl class="img-style" v-show="imgShow" v-if="gifUrl">
    </div>
</template>

<script setup>
    import {ref, reactive, onMounted, defineEmits, onBerforeUnmount, defineExpose} from "vue";
    import {getCurrentInstance} from '@vue/runtime-core';
    // export default {
    //     name: "MoveButton",
    // components: {
    // },
    // setup() {
    const {proxy} = getCurrentInstance();
    const moveBtnRef = ref(null);
    const hide = ref(true);
    const flags = ref(false);
    const position = ref({
        x: 0,
        y: 0
    })
    const nx = ref('');
    const ny = ref('');
    const dx = ref('');
    const dy = ref('');
    const xPum = ref('');
    const yPum = ref('');
    const imgShow = ref(false);
    const moveBtn = ref({});
    const timer = ref(false);
    const currentTop = ref(0);


    const bHeight = ref(0);
    const bottoming = ref(false)

    const gifUrl = ref('')
    const immobileImgUrl = ref('')


    function switchBottom(val, h) {
        console.info(val, h)
        bottoming.value = val
        if (val) {
            bHeight.value = 0
        } else {
            bHeight.value = h
            if (parseInt(moveBtn.value.style.top.slice(0,-2)) >= (document.documentElement.clientHeight + h - 180)) {
                console.info(moveBtn.value.style.top.slice(0,-2), document.documentElement.clientHeight + h)
                moveBtn.value.style.top = document.documentElement.clientHeight - 180 + h + 'px'
            }
        }
    }

    onMounted(() => {
        // console.log(moveBtnRef.value)
        moveBtn.value = moveBtnRef.value
        window.addEventListener("scroll", hideButton);
    }
    )
    ;

    // onBerforeUnmount(() => {
    //     window.addEventListener("scroll", hideButton);
    // })

    function hideButton() {
        timer.value && clearTimeout(timer.value);
        timer.value = setTimeout(() => {
            handleScrollEnd();
        }, 300);
        currentTop.value = document.documentElement.scrollTop || document.body.scrollTop;
        hide.value = false;
    }

    function handleScrollEnd() {
        let scrollTops = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTops === currentTop.value) {
            hide.value = true;
            clearTimeout(timer.value);
        }
    }

    // 实现移动端拖拽
    function btnDown() {
        flags.value = true;
        let touch;
        if (event.touches) {
            touch = event.touches[0];
        } else {
            touch = event;
        }
        position.value.x = touch.clientX;
        position.value.y = touch.clientY;
        dx.value = moveBtn.value.offsetLeft;
        dy.value = moveBtn.value.offsetTop;
    }

    function btnMove() {
        if (flags.value) {
            let touch;
            if (event.touches) {
                touch = event.touches[0];
            } else {
                touch = event;
            }
            nx.value = touch.clientX - position.value.x;
            ny.value = touch.clientY - position.value.y;
            xPum.value = dx.value + nx.value;
            yPum.value = dy.value + ny.value;
            let clientWidth = document.documentElement.clientWidth;
            let clientHeight = document.documentElement.clientHeight //这个是浏览器窗口高度
            // let clientHeight = document.documentElement.scrollHeight; //这个是浏览器页面高度
            if (xPum.value > 0 && xPum.value < (clientWidth - moveBtn.value.offsetWidth)) {
                moveBtn.value.style.left = xPum.value + "px";
            }
            if (bottoming.value) {
                if (yPum.value > 0 && yPum.value < (clientHeight - moveBtn.value.offsetHeight)) {
                    moveBtn.value.style.top = yPum.value + "px";
                }
            } else {
                // console.info(yPum.value + "px", bHeight.value)
                if (yPum.value > 0 && yPum.value < (clientHeight - moveBtn.value.offsetHeight + bHeight.value)) {
                    moveBtn.value.style.top = yPum.value + "px";
                }
            }


            //阻止页面的滑动默认事件
            document.addEventListener("touchmove", handler, {
                passive: false
            });
        }
    }


    //鼠标释放时候的函数
    function btnEnd() {
        flags.value = false;
        document.addEventListener("touchmove", handler, {
            passive: false
        });
    }

    function handler() {
        if (flags.value) {
            event.preventDefault();
        } else {
            return true
        }
    }

    function switchDiagram() {
        console.info(1111)
        imgShow.value = true
    }

    const emit = defineEmits(['openImg']);

    function close() {
        console.info(22222)
        imgShow.value = false
        emit('openImg');
    }

    function imgInit(url) {
        if (!immobileImgUrl.value) {
            immobileImgUrl.value = url
            gifUrl.value = url
        }
    }

    const answerTiming = ref('')
    function actionReception(url, duration) {
        gifUrl.value = url
        clearInterval(answerTiming.value);
        answerTiming.value = null;
        answerTiming.value = setInterval(() => {
            gifUrl.value = immobileImgUrl.value
        }, duration * 1000);
    }

    defineExpose({
        switchDiagram,
        switchBottom,
        imgInit,
        actionReception,
    })
</script>

<style scoped>
    .move-button {
        /*border-radius: 50%;*/
        width: 120px;
        height: 180px;
        position: fixed;
        z-index: 10;
        color: #FFF;
        bottom: 300px;
        left: 30px;
        user-select: none;
    }

    .img-style {
        pointer-events: none;
        /*margin-left: -30px;*/
        width: 110px;
        height: 180px;
    }
</style>
